import type { ReactNode } from "react";
import { Link } from "react-router";

/**
 * The router's link, in the shape the shared components ask for (R22 T13).
 *
 * Several components in `@/design` take a `Link` prop so they can be rendered
 * by either frontend. This is this app's answer to that, in one place: an
 * `href`-shaped signature over `react-router`'s `to`, so nothing in `@/design`
 * has to know which router it is inside.
 */
export function AppLink({
  href,
  className,
  children,
}: {
  href: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}
